import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { UserState } from "../models/UserState";

const setErrorTelVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.telError = action.payload.error;
}

export default setErrorTelVendor;